import { requestUpdateCustomer as requestUpdateCustomerApi } from "@eisinc/App/Services/CustomersService";
import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { UpdateBillToApiParameter } from "@insite/client-framework/Services/CustomersService";
import { BillToModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<UpdateBillToApiParameter & HasOnSuccess, BillToModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await requestUpdateCustomerApi(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => props.parameter.onSuccess?.();

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const requestUpdateBillTo = createHandlerChainRunner(chain, "RequestUpdateBillTo");
export default requestUpdateBillTo;
